import { ICenterUnosDataMonthly } from '@nkr/models/center-profile/unos-data'
import { Alert, Button, Modal, Table } from 'react-bootstrap'
import styled from 'styled-components';

const TableWrapper = styled(Table)`
    & > thead > tr {
        background-color: #133666;
        color: white;
    }

    & > thead > tr > th,
    & > tbody > tr > td {
        text-align: center;
    }
`;

interface IProps {
    show: boolean,
    data: ICenterUnosDataMonthly[],
    isCenter: boolean,
    onDelete: () => void,
    onCancel: () => void
}

const ConfirmDelete = (props: IProps) => {
    return (
        <Modal backdrop='static' bsSize='lg' show={props.show} onHide={props.onCancel}>
            <Modal.Header closeButton>Confirm Deletion of Monthly Data</Modal.Header>
            <Modal.Body>
                <Alert bsStyle='danger' bsSize='sm'>
                    <div style={{ marginBottom: 10 }}>Are you sure you want to delete the following record(s)?</div>
                    <strong>WARNING!!</strong> This action can't be reversed!
                </Alert>

                <TableWrapper bordered condensed>
                    <thead>
                        <tr>
                            {props.isCenter == false && (
                                <th>Center</th>
                            )}
                            <th>Month/Year</th>

                            <th>DD<br />TXPs</th>
                            <th>LD<br />TXPs</th>
                            <th>WL<br />Total</th>
                            <th>WL<br />Active</th>

                            <th>LD<br />ABO A</th>
                            <th>LD<br />ABO B</th>
                            <th>LD<br />ABO AB</th>
                            <th>LD<br />ABO O</th>

                            <th>LD R<br />ABO A</th>
                            <th>LD R<br />ABO B</th>
                            <th>LD R<br />ABO AB</th>
                            <th>LD R<br />ABO O</th>
                        </tr>
                    </thead>

                    <tbody>
                        {props.data.map(item =>
                            <tr>
                                {props.isCenter == false && (
                                    <td>{item.cAlias}</td>
                                )}
                                <td>{item.date}</td>

                                <td>{item.ddTxps}</td>
                                <td>{item.ldTxps}</td>
                                <td>{item.wlTotal}</td>
                                <td>{item.wlActive}</td>

                                <td>{item.lda}</td>
                                <td>{item.ldab}</td>
                                <td>{item.ldab}</td>
                                <td>{item.ldo}</td>

                                <td>{item.ldra}</td>
                                <td>{item.ldrab}</td>
                                <td>{item.ldrab}</td>
                                <td>{item.ldro}</td>
                            </tr>
                        )}
                    </tbody>
                </TableWrapper>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onDelete}>Yes, Delete</Button>
                <Button onClick={props.onCancel}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;